// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Debug Trigger Styles */
.admin-debug-trigger {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

.debug-trigger-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(108, 117, 125, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: pulse 2s infinite;
}

/* Locked state (no role access) */
.debug-trigger-btn.locked {
  background: linear-gradient(135deg, #6c757d, #495057);
  box-shadow: 0 4px 20px rgba(108, 117, 125, 0.3);
}

.debug-trigger-btn.locked:hover {
  box-shadow: 0 6px 30px rgba(108, 117, 125, 0.5);
}

/* Authorized state (admin role) */
.debug-trigger-btn.authorized {
  background: linear-gradient(135deg, #ff8800, #e67700);
  box-shadow: 0 4px 20px rgba(255, 136, 0, 0.3);
}

.debug-trigger-btn.authorized:hover {
  box-shadow: 0 6px 30px rgba(255, 136, 0, 0.5);
}

/* Super Admin state */
.debug-trigger-btn.super-admin {
  background: linear-gradient(135deg, #ff4444, #cc0000);
  box-shadow: 0 4px 20px rgba(255, 68, 68, 0.3);
  border: 2px solid #ffd700;
}

.debug-trigger-btn.super-admin:hover {
  box-shadow: 0 6px 30px rgba(255, 68, 68, 0.5);
  border-color: #ffed4e;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 4px 20px rgba(0, 212, 170, 0.3);
  }
  50% {
    box-shadow: 0 4px 30px rgba(0, 212, 170, 0.5);
  }
}

/* Pulse animation for different roles */
.debug-trigger-btn.authorized {
  animation: pulseOrange 2s infinite;
}

.debug-trigger-btn.super-admin {
  animation: pulseRed 2s infinite;
}

@keyframes pulseOrange {
  0%, 100% {
    box-shadow: 0 4px 20px rgba(255, 136, 0, 0.3);
  }
  50% {
    box-shadow: 0 4px 30px rgba(255, 136, 0, 0.5);
  }
}

@keyframes pulseRed {
  0%, 100% {
    box-shadow: 0 4px 20px rgba(255, 68, 68, 0.3);
  }
  50% {
    box-shadow: 0 4px 30px rgba(255, 68, 68, 0.5);
  }
}

.debug-trigger-btn:hover {
  transform: scale(1.1);
  animation: none;
}

.debug-trigger-btn.active {
  background: linear-gradient(135deg, #dc3545, #c82333);
  box-shadow: 0 4px 20px rgba(220, 53, 69, 0.3);
  animation: none;
}

.debug-trigger-btn.active:hover {
  box-shadow: 0 6px 30px rgba(220, 53, 69, 0.5);
}

.debug-trigger-tooltip {
  position: absolute;
  bottom: 70px;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  border: 1px solid #333;
  backdrop-filter: blur(4px);
}

.debug-trigger-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 20px;
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

.admin-debug-trigger:hover .debug-trigger-tooltip {
  opacity: 1;
}

/* Password Protection Modal */
.password-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.password-modal {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  min-width: 320px;
  max-width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: translateY(-20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

.password-header {
  text-align: center;
  margin-bottom: 20px;
}

.password-header h3 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 20px;
}

.password-header p {
  margin: 0 0 8px 0;
  color: #666;
  font-size: 14px;
}

.password-header small {
  color: #999;
  font-size: 12px;
  font-style: italic;
}

.password-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.password-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.password-input {
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  transition: border-color 0.3s ease;
  background: #f8f9fa;
}

.password-input:focus {
  outline: none;
  border-color: #00d4aa;
  background: #fff;
}

.password-input.error {
  border-color: #dc3545;
  background: #fff5f5;
}

.password-error {
  color: #dc3545;
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
}

.password-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-cancel, .btn-submit {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel {
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.btn-cancel:hover {
  background: #e9ecef;
  color: #495057;
}

.btn-submit {
  background: linear-gradient(135deg, #00d4aa, #00a085);
  color: white;
}

.btn-submit:hover {
  background: linear-gradient(135deg, #00a085, #008066);
  transform: translateY(-1px);
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .admin-debug-trigger {
    bottom: 15px;
    right: 15px;
  }
  
  .debug-trigger-btn {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }

  .password-modal {
    margin: 20px;
    min-width: unset;
    width: calc(100% - 40px);
  }

  .password-actions {
    flex-direction: column;
  }

  .btn-cancel, .btn-submit {
    width: 100%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/AdminDebugTrigger.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,eAAe;EACf,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA,wCAAwC;AACxC;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Debug Trigger Styles */\n.admin-debug-trigger {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n}\n\n.debug-trigger-btn {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: none;\n  background: linear-gradient(135deg, #6c757d, #495057);\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  box-shadow: 0 4px 20px rgba(108, 117, 125, 0.3);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  animation: pulse 2s infinite;\n}\n\n/* Locked state (no role access) */\n.debug-trigger-btn.locked {\n  background: linear-gradient(135deg, #6c757d, #495057);\n  box-shadow: 0 4px 20px rgba(108, 117, 125, 0.3);\n}\n\n.debug-trigger-btn.locked:hover {\n  box-shadow: 0 6px 30px rgba(108, 117, 125, 0.5);\n}\n\n/* Authorized state (admin role) */\n.debug-trigger-btn.authorized {\n  background: linear-gradient(135deg, #ff8800, #e67700);\n  box-shadow: 0 4px 20px rgba(255, 136, 0, 0.3);\n}\n\n.debug-trigger-btn.authorized:hover {\n  box-shadow: 0 6px 30px rgba(255, 136, 0, 0.5);\n}\n\n/* Super Admin state */\n.debug-trigger-btn.super-admin {\n  background: linear-gradient(135deg, #ff4444, #cc0000);\n  box-shadow: 0 4px 20px rgba(255, 68, 68, 0.3);\n  border: 2px solid #ffd700;\n}\n\n.debug-trigger-btn.super-admin:hover {\n  box-shadow: 0 6px 30px rgba(255, 68, 68, 0.5);\n  border-color: #ffed4e;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    box-shadow: 0 4px 20px rgba(0, 212, 170, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 30px rgba(0, 212, 170, 0.5);\n  }\n}\n\n/* Pulse animation for different roles */\n.debug-trigger-btn.authorized {\n  animation: pulseOrange 2s infinite;\n}\n\n.debug-trigger-btn.super-admin {\n  animation: pulseRed 2s infinite;\n}\n\n@keyframes pulseOrange {\n  0%, 100% {\n    box-shadow: 0 4px 20px rgba(255, 136, 0, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 30px rgba(255, 136, 0, 0.5);\n  }\n}\n\n@keyframes pulseRed {\n  0%, 100% {\n    box-shadow: 0 4px 20px rgba(255, 68, 68, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 30px rgba(255, 68, 68, 0.5);\n  }\n}\n\n.debug-trigger-btn:hover {\n  transform: scale(1.1);\n  animation: none;\n}\n\n.debug-trigger-btn.active {\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  box-shadow: 0 4px 20px rgba(220, 53, 69, 0.3);\n  animation: none;\n}\n\n.debug-trigger-btn.active:hover {\n  box-shadow: 0 6px 30px rgba(220, 53, 69, 0.5);\n}\n\n.debug-trigger-tooltip {\n  position: absolute;\n  bottom: 70px;\n  right: 0;\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  border: 1px solid #333;\n  backdrop-filter: blur(4px);\n}\n\n.debug-trigger-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  right: 20px;\n  border: 5px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.admin-debug-trigger:hover .debug-trigger-tooltip {\n  opacity: 1;\n}\n\n/* Password Protection Modal */\n.password-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.password-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  min-width: 320px;\n  max-width: 400px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from { \n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.password-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.password-header h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.password-header p {\n  margin: 0 0 8px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.password-header small {\n  color: #999;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.password-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.password-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.password-input {\n  padding: 12px 16px;\n  border: 2px solid #e1e5e9;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  transition: border-color 0.3s ease;\n  background: #f8f9fa;\n}\n\n.password-input:focus {\n  outline: none;\n  border-color: #00d4aa;\n  background: #fff;\n}\n\n.password-input.error {\n  border-color: #dc3545;\n  background: #fff5f5;\n}\n\n.password-error {\n  color: #dc3545;\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.password-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.btn-cancel, .btn-submit {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-cancel {\n  background: #f8f9fa;\n  color: #6c757d;\n  border: 1px solid #dee2e6;\n}\n\n.btn-cancel:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.btn-submit {\n  background: linear-gradient(135deg, #00d4aa, #00a085);\n  color: white;\n}\n\n.btn-submit:hover {\n  background: linear-gradient(135deg, #00a085, #008066);\n  transform: translateY(-1px);\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n  .admin-debug-trigger {\n    bottom: 15px;\n    right: 15px;\n  }\n  \n  .debug-trigger-btn {\n    width: 50px;\n    height: 50px;\n    font-size: 20px;\n  }\n\n  .password-modal {\n    margin: 20px;\n    min-width: unset;\n    width: calc(100% - 40px);\n  }\n\n  .password-actions {\n    flex-direction: column;\n  }\n\n  .btn-cancel, .btn-submit {\n    width: 100%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
